var _path, _path2;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUsers = function SvgUsers(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75v-1.5a3 3 0 0 0-3-3H3.75a3 3 0 0 0-3 3v1.5M6.375 8.25a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17.2 15.75v-1.5a3 3 0 0 0-3-3h-1.594M10.167 7.9a3 3 0 1 0 .05-5.325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75v-1.5a3 3 0 0 0-3-3H3.75a3 3 0 0 0-3 3v1.5"
  })));
};
export default SvgUsers;